<script setup>
    import { ref, onMounted, getCurrentInstance } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { usePageLoadingStore } from "../../../../stores/pageLoading";
    import SNBAdmin from '../../../../layouts/nav/SNBAdmin.vue'
    import adminPartnerService from "../../services/partner/adminPartnerService";
    import KSAInputGeneralPhoneNum from "../../../../components/ui-components/input/KSAInputGeneralPhoneNum.vue";
    import { useAlertStore } from '../../../../stores/alertStore';
    import KSACertificateTemplatePreview from "../../../../components/ui-components/KSACertificateTemplatePreview.vue";
    import LectureCertificateTemplateSearchModal from "../../../../pages/admin/components/modal/lecture/LectureCertificateTemplateSearchModal.vue";
    import _ from 'lodash'

    const searchCertificateTemplateModal = ref(null);
   
    const { $alert, $confirm } = useAlertStore();

    const { $regex, $toast, $number } = getCurrentInstance().appContext.config.globalProperties;

    const route = useRoute();
    const router = useRouter();
    const loadingStore = usePageLoadingStore();

    const loaded = ref(false); // 데이터 받고 난 후, 화면 그리는 용도

    onMounted(()=>{
        const { id } = route.params;
        if(!id) {
            router.push({name: 'PartnerList'})
        } else {
            retrievePartner(id)
        }
    })
    const editorRef = ref(null)

    const input = ref({
        partnerName: "",     // 담당기관명
        partnerStartYmd: "", // 담당기간(시작일)
        partnerEndYmd: "",   // 담당기간(종료일)
        ceoName: "",         // 대표자명
        partnerPhoneNum: "", // 담당기관대표연락처
        partnerEmail: "",    // 담당기관이메일
        chargeName: "",      // 담당자명
        chargePhoneNum: "",  // 담당자연락처
        chargeEmail: "",     // 담당자이메일
    })

    const inputCertificateTemplate = ref({
        templateId: '',
        certificateName: '',
        frontFixedText: '',
        frontImageName: '',
        frontImageSize: '',
        frontImageDir: '',
        backImageName: '',
        backImageSize: '',
        backImageDir: '',
    })

    // 담당기관 상세 조회
    const retrievePartner = (id) => {
        loadingStore.loading = true;
        loaded.value = false; // 데이터 받기 전에 화면 안 그리기
        adminPartnerService.retrievePartner(id)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    input.value = res.data.result;
                    loaded.value = true; // 데이터 받고 나서 화면 그리기

                    if(input.value.certificateTemplate) {
                        inputCertificateTemplate.value = {
                            templateId: input.value.certificateTemplate.templateId,
                            certificateName: input.value.certificateTemplate.certificateName,
                            frontFixedText: input.value.certificateTemplate.frontFixedText,
                            frontImageName: input.value.certificateTemplate.frontImageName,
                            frontImageSize: input.value.certificateTemplate.frontImageSize,
                            frontImageDir: input.value.certificateTemplate.frontImageDir,
                            backImageName: input.value.certificateTemplate.backImageName,
                            backImageSize: input.value.certificateTemplate.backImageSize,
                            backImageDir: input.value.certificateTemplate.backImageDir, 
                        };
                    }
                }
            }).catch( (error) =>  {
                loadingStore.loading = false;
                $toast("error", error);
        });
    }

    // 담당기관 수정
    const update = () => {
        const request = _.cloneDeep(input.value);
        const {
            partnerName,     // 담당기관명
            partnerStartYmd, // 담당기간(시작일)
            partnerEndYmd,   // 담당기간(종료일)
            ceoName,         // 대표자명
            partnerPhoneNum, // 담당기관대표연락처
            partnerEmail,    // 담당기관이메일
            chargeName,      // 담당자명
            chargePhoneNum,  // 담당자연락처
            chargeEmail,     // 담당자이메일
        } = request;

        if(!partnerName) {
            $alert(["담당기관명을 입력하세요"]);
            return false;
        }
        if(partnerStartYmd == null || partnerStartYmd === '' || $number(partnerStartYmd) === '0') {
            $alert(["담당기간(시작일)을 입력하세요."]);
            return false;
        }
        if(partnerEndYmd == null || partnerEndYmd === '' || $number(partnerEndYmd) === '0'){
            $alert(["담당기간(종료일)을 입력하세요."]);
            return false;
        }
        if(partnerStartYmd > partnerEndYmd){
            $alert(["담당기간(시작일)은 담당기간(종료일)보다 빨라야합니다."]);
            return false;
        }
        if(!partnerPhoneNum){
            $alert(["담당기관 연락처를 입력하세요."]);
            return false;
        } else {
            if(!$regex.generalPhoneNum.test(partnerPhoneNum)) {
                $alert(["유효한 담당기관 연락처를 입력하세요."]);
                return false;
            }
        }
        if(!partnerEmail){
            $alert(["담당기관 이메일을 입력하세요."]);
            return false;
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!emailRegex.test(partnerEmail)) {
                $alert(["유효한 담당기관 이메일 형식을 입력하세요."]);
                return false;
            }
        }
        if(chargePhoneNum) {
            if(!$regex.generalPhoneNum.test(chargePhoneNum)) {
                $alert(["유효한 담당자 연락처를 입력하세요."]);
                return false;
            }
        }
        if(chargeEmail) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!emailRegex.test(chargeEmail)) {
                $alert(["유효한 담당자 이메일 형식을 입력하세요."]);
                return false;
            }
        }

        if(!inputCertificateTemplate.value.templateId) {
            $alert(["수료증 양식을 선택하세요."]);
            return false;
        }

        const requestParam = {
            ...request,
            templateId: inputCertificateTemplate.value.templateId,
        };

        loadingStore.loading = true;
        adminPartnerService.updatePartner(requestParam)
            .then( async (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    $alert(["변경사항을 등록하였습니다."]);
                    goDetail();
                } else {
                    $alert(["변경사항 등록을 실패하였습니다."]);
                }
            }).catch( (res) =>  {
                loadingStore.loading = false;
            $toast("error", res.response.data.result.message);
        });
    }

    // 담당기관상세로 가기
    const goDetail = () => {
        router.push({name: 'PartnerDetail', params: {id: input.value.partnerId}});
    }

    // 수료증 양식 > 검색
    const onClickSearchCertificateTemplate = async () => {
        searchCertificateTemplateModal.value.init();
        const result = await searchCertificateTemplateModal.value.show();
        if( result ) {
          inputCertificateTemplate.value = result;
        }
    };

</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>담당기관 수정</h3>
            <p><span>* 표시는 필수 입력사항</span> 입니다.</p>
        </div>
        <div v-if="loaded" class="table-form">
            <table class="vertical">
                <colgroup>
                    <col width="200px" />
                    <col />
                </colgroup>
                <tr>
                    <th class="mark">담당기관명</th>
                    <td>
                        <KSAInput class="text-box" v-model="input.partnerName" max-length="50" placeholder="담당기관명을 입력해주세요."/>
                    </td>
                </tr>
                <tr>
                    <th class="mark">담당기간</th>
                    <td class="text-box">
                        <div style="display: inline-block;">
                            <KSADatepickerTerms
                                :startDate="input.partnerStartYmd"
                                :endDate="input.partnerEndYmd"
                                @update:startDate="(value)=> input.partnerStartYmd = value"
                                @update:endDate="(value)=> input.partnerEndYmd = value"
                            />
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>대표자명</th>
                    <td>
                        <KSAInput class="text-box" v-model="input.ceoName" max-length="50" placeholder="담당기관 대표자명을 입력해주세요."/>
                    </td>
                </tr>
                <tr>
                    <th class="mark">담당기관 연락처</th>
                    <td>
                        <KSAInputGeneralPhoneNum class="text-box" v-model="input.partnerPhoneNum" max-length="13" placeholder="담당기관 연락처를 입력해주세요."/>
                    </td>
                </tr>
                <tr>
                    <th class="mark">담당기관 이메일</th>
                    <td>
                        <KSAInput class="text-box" v-model="input.partnerEmail" max-length="50" placeholder="담당기관 이메일을 입력해주세요."/>
                    </td>
                </tr>
                <tr>
                    <th>담당자명</th>
                    <td>
                        <KSAInput class="text-box" v-model="input.chargeName" max-length="50" placeholder="담당자명을 입력해주세요."/>
                    </td>
                </tr>
                <tr>
                    <th>담당자 연락처</th>
                    <td>
                        <KSAInputGeneralPhoneNum class="text-box" v-model="input.chargePhoneNum" max-length="13" placeholder="담당자 연락처를 입력해주세요."/>
                    </td>
                </tr>
                <tr>
                    <th>담당자 이메일</th>
                    <td>
                        <KSAInput class="text-box" v-model="input.chargeEmail" max-length="50" placeholder="담당자 이메일을 입력해주세요."/>
                    </td>
                </tr>
                <tr>
                    <th class="mark">강의 수료증 양식</th>
                    <td class="text-box">
                        <div class="grid">
                            <KSAPrimaryButton text="검색" @click="onClickSearchCertificateTemplate" />
                            <KSACertificateTemplatePreview 
                                :headSrc="inputCertificateTemplate.frontImageDir"
                                :tailSrc="inputCertificateTemplate.backImageDir"
                                :title="inputCertificateTemplate.certificateName"
                                :frontFixedText="inputCertificateTemplate.frontFixedText"
                            />
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="btn-wrap space-between">
            <KSASecondaryButton class="gray_button" text="취소" @click="goDetail" />
            <KSAPrimaryButton text="수정" @click="update" />
        </div>
    </div>
    <LectureCertificateTemplateSearchModal ref="searchCertificateTemplateModal"/>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

</style>